<template>
  <svg
    class="expand-icon"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.50308 6.68034C1.92825 6.68034 2.27275 6.33573 2.27275 5.91066V2.62896L7.22999 7.58517C7.38033 7.73541 7.57727 7.81053 7.7742 7.81053C7.97124 7.81053 8.16828 7.73541 8.31852 7.58507C8.6191 7.28448 8.6191 6.79712 8.31841 6.49664L3.36097 1.54033H6.64339C7.06846 1.54033 7.41307 1.19572 7.41307 0.770654C7.41307 0.345587 7.06856 0.000976562 6.64339 0.000976562H1.50308C1.07791 0.000976562 0.733398 0.345587 0.733398 0.770654V5.91076C0.733398 6.33573 1.07791 6.68034 1.50308 6.68034Z"
      fill="#2C3236"
    />
    <path
      d="M22.0636 15.4205C21.6384 15.4205 21.2939 15.7651 21.2939 16.1902V19.472L16.1841 14.3622C15.8834 14.0616 15.3961 14.0616 15.0956 14.3622C14.795 14.6627 14.795 15.1501 15.0956 15.4506L20.2053 20.5603H16.9237C16.4985 20.5603 16.154 20.9049 16.154 21.33C16.154 21.7551 16.4985 22.0997 16.9237 22.0997H22.0637C22.4889 22.0997 22.8334 21.7551 22.8334 21.33V16.1902C22.8333 15.7651 22.4887 15.4205 22.0636 15.4205Z"
      fill="#2C3236"
    />
    <path
      d="M7.38256 14.3622L2.27324 19.4719V16.1902C2.27324 15.7651 1.92873 15.4205 1.50356 15.4205C1.07839 15.4205 0.733887 15.7651 0.733887 16.1902V21.3302C0.733887 21.7553 1.07839 22.0999 1.50356 22.0999H6.64337C7.06843 22.0999 7.41304 21.7553 7.41304 21.3302C7.41304 20.9051 7.06854 20.5605 6.64337 20.5605H3.36167L8.47109 15.4506C8.77168 15.15 8.77168 14.6627 8.47099 14.3621C8.17061 14.0616 7.68325 14.0616 7.38256 14.3622Z"
      fill="#2C3236"
    />
    <path
      d="M22.0636 0.000488281H16.9236C16.4984 0.000488281 16.1539 0.345098 16.1539 0.770166C16.1539 1.19523 16.4984 1.53984 16.9236 1.53984H20.2054L15.2489 6.49667C14.9483 6.79725 14.9483 7.28461 15.249 7.5852C15.3992 7.73544 15.5962 7.81056 15.7932 7.81056C15.9901 7.81056 16.1871 7.73533 16.3375 7.58509L21.294 2.62827V5.91017C21.294 6.33524 21.6385 6.67985 22.0637 6.67985C22.4889 6.67985 22.8334 6.33524 22.8334 5.91017V0.770166C22.8333 0.344996 22.4886 0.000488281 22.0636 0.000488281Z"
      fill="#2C3236"
    />
  </svg>
</template>

<script>
  export default {
    name: 'resizeIcon'
  }
</script>



// WEBPACK FOOTER //
// src/assets/icons/resizeIcon.vue